import { Upload as Dragger } from '@/components/ui/Upload';
import { UploadCloud } from 'lucide-react';
import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
} from './ui/Dialog';
import { Button } from './ui/Button';
import { apiService } from '../utils/api';

const FileUploader = ({ url, visible, onSubmit, onClose }) => {
  const [loading, setLoading] = useState(false);

  const upload = async (options) => {
    const { file } = options;

    const fmData = new FormData();
    const config = {
      headers: { 'content-type': 'multipart/form-data' },
    };

    fmData.append('file', file);

    setLoading(true);
    try {
      const res = await apiService.post(url, fmData, config);

      if (res.data) {
        onSubmit({ id: res.data.id, title: file.name });
      }
    } catch (err) {
      console.log('Eroor: ', err);
    } finally {
      setLoading(false);
    }
  };

  const config = {
    name: 'file',
    multiple: true,
    accept: '.pdf, .doc, image/*',
    customRequest: upload,
    showUploadList: false,
  };

  return (
    <Dialog open={visible} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Nahrát soubor</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="flex flex-col h-auto">
            <Dragger {...config}>
              <div className="flex flex-col items-center justify-center gap-4 rounded-xl border-2 border-dashed border-neutral-300 bg-neutral-25/50 px-6 py-12 text-center transition-colors hover:border-primary-300 hover:bg-neutral-50 group-data-[dragging=true]:border-primary-400 group-data-[dragging=true]:bg-primary-50">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 text-primary-600 transition-colors group-data-[dragging=true]:bg-primary-100">
                  <UploadCloud className="h-8 w-8" />
                </div>
                <div className="space-y-1">
                  <p className="text-sm font-medium text-neutral-800">
                    Klikni nebo přetáhni soubor pro nahrání
                  </p>
                  <p className="text-xs text-neutral-500">PDF, DOC nebo obrázek</p>
                </div>
              </div>
            </Dragger>
          </div>
        </DialogBody>
        <DialogFooter>
          <Button
            data-testid="file-uploader-close-btn"
            key={1}
            variant="outline"
            onClick={() => onClose()}
          >
            Zavřít
          </Button>
          <Button type="button" data-testid="file-uploader-confirm-btn" key={2} disabled={loading}>
            Potvrdit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default FileUploader;
